module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('color-picker', {
    attrs: {
      "label": _vm.$t('edit.sidebar.background_color'),
      "id": _vm.getId(),
      "value": _vm.value(),
      "change": _vm.onColorChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0d2aef28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/editors/BackgroundColor.vue
 ** module id = 760
 ** module chunks = 1
 **/